import { axiosAuth } from './axiosInstances'

// KHAN-228: apps.Widget -> apps.widget, api/widget/{insertWidgetItem,
// updateWidgetitem,listallWidgets,listallWidgetItems} -> recursos REST
// api/widgets/ y api/widget-items/ con verbos HTTP (GET/POST/PATCH). Todas
// las funciones exportadas conservan su firma y su forma de respuesta --
// solo cambia el metodo/path de la llamada HTTP.

export async function newWidgetItem(page, widget, type, value, elementorder) {

  return axiosAuth().post('widget-items/', {
    pageid: page,
    widgetid: widget,
    type: type,
    value: value,
    elementorder: elementorder,
  })
}

export async function updateWidgetItem(widgetitemid, pageid, widgetid, type, value, elementorder) {
  // Antes PUT widget/updateWidgetitem/ con el id en el body; ahora PATCH
  // widget-items/{id}/ direccionado por el pk en la URL (partial_update,
  // el backend ya no acepta PUT en este recurso).
  return axiosAuth().patch(`widget-items/${widgetitemid}/`, {
    pageid,
    widgetid,
    type,
    value,
    elementorder,
  });
}

export async function listedWidgets() {
  return axiosAuth().get('widgets/')
}

export async function listedWidgetItems() {
  return axiosAuth().get('widget-items/')
}
